<template>
  <validated-select
    :name="name"
    :label="label"
    :options="options"
    :rules="rules"
    :disabled="disabled"
    searchable
    :loading="countriesLoading"
    :initial-value="loadDefault ? requestCountry : null" />
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    rules: {
      type: String,
      required: false,
      default: null
    },
    loadDefault: {
      type: Boolean,
      required: false,
      default: true,
    }
  },
  created() {
    if (!this.countryList) {
      this.fetchCountryList();
    }
  },
  computed: {
    ...mapState('generic', ['requestCountry', 'countryList']),
    options() {
      return this.countryList ?? {};
    },
    countriesLoading() {
      return !this.countryList;
    }
  },
  methods: {
    ...mapActions('generic', ['fetchCountryList']),
  }
};
</script>
